import React, { useEffect, useState } from 'react';

import { Banner, Header, Eventos, Casa, Buffet, Footer, Estacionamento, Contato } from '../../Componentes';
import { teste } from '../../Componentes/dynatrace';

import Load from '../../Componentes/Load';
import * as S from './estilos';
import { Oval } from 'react-loader-spinner';

import ImgBanner from '../../Images/Banner.jpg';
import ImgBannerResp from '../../Images/BannerResp.jpg';

import ImgBanner1 from '../../Images/Banner1.jpg';
import ImgBannerResp1 from '../../Images/BannerResp1.jpg';

import ImgBanner2 from '../../Images/Banner2.jpg';
import ImgBannerResp2 from '../../Images/BannerResp2.jpg';
import 'react-confirm-alert/src/react-confirm-alert.css';

function Home(props: any) {
  useEffect(() => {
    const hash = props.history.location.hash;
    if (hash && document.getElementById(hash.substr(1))) {
      // Check if there is a hash and if an element with that id exists
      document.getElementById(hash.substr(1))?.scrollIntoView({ behavior: 'smooth' });
    }
    // }, []);
  }, [props.history.location.hash]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const bannerData = [
    {
      normal: ImgBanner,
      responsive: ImgBannerResp,
      link: 'http://www.uol.com.brzzzz',
    },
    {
      normal: ImgBanner1,
      responsive: ImgBannerResp1,
      link: 'http://www.uol.com.brzzzz',
    },
    {
      normal: ImgBanner2,
      responsive: ImgBannerResp2,
      link: 'http://www.uol.com.brzzzz',
    },
  ];

  return (
    <>
      <link rel='stylesheet' href='fontes/stylesheet.css' />
      {/* <Load status={load} /> */}
      <Header />

      <Banner data={bannerData} />

      <Casa />

      <Buffet />

      <Estacionamento />

      {/* <Eventos /> */}

      <Contato />

      <Footer />
    </>
  );
}

export default Home;
